import Jost400 from "./jost-400-book.woff"
import Jost500 from "./jost-500-medium.woff"
import Jost600 from "./jost-600-semi.woff"
import Jost700 from "./jost-700-bold.woff"
import Jost800 from "./jost-800-heavy.woff"
import Source from "./SourceSerifPro-Regular.ttf"
import SourceItalic from "./SourceSerifPro-Italic.ttf"
// import SourceBold from "./SourceSerifPro-Bold.ttf"
// import SourceBoldItalic from "./SourceSerifPro-BoldItalic.tff"
import SourceSemiBold from "./SourceSerifPro-SemiBold.ttf"
import SourceSemiBoldItalic from "./SourceSerifPro-SemiBoldItalic.ttf"

const fonts = {
  "@font-face": [
    {
      fontFamily: "Jost",
      src: `url('${Jost400}') format("woff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Jost",
      src: `url('${Jost500}') format("woff")`,
      fontWeight: 500,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Jost",
      src: `url('${Jost600}') format("woff")`,
      fontWeight: 600,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Jost",
      src: `url('${Jost700}') format("woff")`,
      fontWeight: 700,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Jost",
      src: `url('${Jost800}') format("woff")`,
      fontWeight: 800,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    //
    {
      fontFamily: "SourceSerifPro",
      src: `url('${Source}') format("tff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "SourceSerifPro",
      src: `url('${SourceItalic}') format("tff")`,
      fontWeight: 400,
      fontStyle: "italic",
      fontDisplay: "swap",
    },
    // {
    //   fontFamily: "SourceSerifPro",
    //   src: `url('${SourceBold}') format("tff")`,
    //   fontWeight: 800,
    //   fontStyle: "normal",
    //   fontDisplay: "swap",
    // },
    // {
    //   fontFamily: "SourceSerifPro",
    //   src: `url('${SourceBoldItalic}') format("tff")`,
    //   fontWeight: 800,
    //   fontStyle: "italic",
    //   fontDisplay: "swap",
    // },
    {
      fontFamily: "SourceSerifPro",
      src: `url('${SourceSemiBold}') format("tff")`,
      fontWeight: 600,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "SourceSerifPro",
      src: `url('${SourceSemiBoldItalic}') format("tff")`,
      fontWeight: 600,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
  ],
}

export default fonts
